import { render, staticRenderFns } from "./SwiperQRcourses.vue?vue&type=template&id=5ec7cdb2&"
import script from "./SwiperQRcourses.vue?vue&type=script&lang=js&"
export * from "./SwiperQRcourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports